<template lang="pug">
  div.sizeWidth
    button.tl(:style="sty()",@mousedown="mousedown")
      img(src="@/assets/ico_tgl_lr.svg")
</template>

<script>
export default {
  name: 'SizeWidth',
  components: {
  },
  data () {
    return {
      prev: 0,
      left: 0,
      kwd: 0,
      set: {},
      flg: false
    };
  },
  props: {
    // wd: Number
  },
  computed: {
  },
  watch: {
    number () {
      this.set = this.sets[this.number];
      if (this.set !== undefined) {
        this.left = this.c2p(this.set.slits[this.set.slits.length - 1].pos);
        this.kwd = this.c2p(this.set.slits[this.set.slits.length - 1].pos);
      }
    },
    sets () {
      this.update();
    }
  },
  methods: {
    update () {
      this.set = this.sets[this.number];
      if (this.set !== undefined) {
        this.left = this.c2p(this.set.slits[this.set.slits.length - 1].pos);
      }
    },
    mousedown (e) {
      this.startX = this.mp(e).clientX;
      this.flg = true;
      window.addEventListener('mousemove', this.mousemove);
      window.addEventListener('mouseup', this.mouseup, false);
      this.prev = this.width;
    },
    mousemove (e) {
      if (this.flg) {
        let prev = Math.round((this.mp(e).clientX - this.startX) / 50) * 50 + this.kwd;
        let prePos = this.set.slits[this.set.slits.length - 2].pos;
        if (prev - this.c2p(prePos) <= 150) {
          this.width = this.c2p(prePos) + 150;
        } else if (prev - this.c2p(prePos) >= 300) {
          this.width = this.c2p(prePos) + 300;
        } else if (prev < 150) {
          this.width = 150;
        } else if (prev > this.c2p(270)) {
          this.width = this.c2p(270);
        } else {
          this.width = prev;
        }
        this.$emit('change', this.p2c(this.width));
        this.prev = this.width;
      }
    },
    mouseup () {
      this.flg = false;
      this.kwd = this.c2p(this.set.slits[this.set.slits.length - 1].pos);
      window.removeEventListener('mouseup', this.mouseup);
    },
    sty () {
      return {
        left: this.left + 'px'
      };
    }
  },
  created () {
    // this.width = this.wd;
    this.set = this.sets[this.number];
    if (this.set !== undefined) {
      this.left = this.c2p(this.set.slits[this.set.slits.length - 1].pos);
      this.kwd = this.c2p(this.set.slits[this.set.slits.length - 1].pos);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .sizeWidth
    position absolute
    left 0
    top 0
    bottom 0
    z-index 1
  .tl
    position absolute
    left 0
    bottom 50%
    transform translate(50%,50%)
    padding 0
    img
      pointer-events none
</style>



// WEBPACK FOOTER //
// src/components/front/SizeWidth.vue